<template>
  <div class="about">
    <el-row class="main" type="flex" justify="center">
      <el-col :xs="{span:23,offset:0}" :sm="{span:16,offset:0}" :md="{span:10,offset:0}">
        <div class="myself-img">
          <div class="block">
            <img class="myself-png" style="width: 150px; height: 150px; border-radius: 50%;" src="../assets/myself.png">
          </div>
          <div class="vue-type">
            <vue-typer :text='vueTypeText' :type-delay='200' eraseStyle='select-all'></vue-typer>
          </div>
        </div>
        <h5 class="title"><i class="el-icon-star-on"></i>{{"关于自己"}}</h5>
        <el-card shadow="always">
          <div class="item">姓名：孙本固</div>
          <div class="item">职业：unity3d程序员</div>
          <div class="item">前端技术栈：unity3d、vue</div>
          <div class="item">后端技术栈：.net core、linux、docker</div>
        </el-card>
        <h5 class="title"><i class="el-icon-star-on"></i>{{"关于博客"}}</h5>
        <el-card shadow="always">
          <dl class="dl-blog">
            <dt>{{"博客主页"}}</dt>
            <dd>
              <a target="_blank" href="http://www.sunbengu.com/">{{"http://www.sunbengu.com/"}}</a>
            </dd>
            <dt>{{"建站技术"}}</dt>
            <dd>Vue、Vuex、Vue-Router、Element-ui、.net core、docker</dd>
            <dt>{{"博客内容"}}</dt>
            <dd>本站仅用于记录与整理个人的编程开发笔记，欢迎交流与探讨！</dd>
          </dl>
        </el-card>
        <h5 class="title"><i class="el-icon-star-on"></i>{{"交流联系"}}</h5>
        <div class="statement">
          <div class="item">Email：scalin@vip.qq.com</div>
          <div class="item">QQ：372479329</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'about',
  data() {
    return {
      vueTypeText: ["在下，unity3d程序员一枚", "工作八九载", "座右铭：不积跬步，无以至千里；不积小流，无以成江海。"],
    };
  },
  created() {
    this.$store.commit("setActiveIndex", "/about");
    window.scroll(0, 0);
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.vue-type {
  margin-top: 40px;
}

.dl-blog dd {
  margin-left: 0px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.dl-blog .icon {
  width: 20px;
  height: 20px;
}

.title {
  margin-top: 60px;
  margin-bottom: 20px;
}

.statement {
  border-left: 3px solid #f56c6c;
  padding: 20px;
  background-color: #ebeef5;
  margin-top: 20px;
}

.item {
  margin-bottom: 20px;
}

.statement .item {
  margin-top: 10px;
  margin-bottom: 10px;
}

.myself-img {
  text-align: center;
}

.myself-png {
  object-fit: contain;
}
</style>